import { dateFormat } from "@evergis/ui";

import { RangeClass, UniqueClass } from "../../../interfaces/classification";
import { formatValue } from "../../../modules/FeatureCard/components/Attributes/FeatureAttributeField";
import { getRangeValues } from "./rangeClassValue";

export const formatUniqueClassValue = (value: UniqueClass): string => {
  const { attribute, uniqueValue } = value;

  return attribute ? formatValue(uniqueValue, attribute.type) : uniqueValue;
};

export const formatRangeClassValue = (value: RangeClass, index: number): string => {
  const isDouble = value.attribute?.type === "Double";
  const isDate = value.attribute?.type === "DateTime";

  const { from, to } = getRangeValues(value, isDouble, isDate, index);

  const formattedFrom = isDate && from ? dateFormat(new Date(from), true) : from;
  const formattedTo = isDate && to ? dateFormat(new Date(to), true) : to;

  if (from === null) {
    return `${formattedTo}${!isDate ? " и менее" : ""}`;
  }

  if (to === null) {
    return `${!isDate ? "более " : ""}${formattedFrom}`;
  }

  return from === to ? `${formattedFrom}` : `${formattedFrom} - ${formattedTo}`;
};
